import Vue from 'vue'
import Vuelidate from 'vuelidate'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import VueSelect from 'vue-select'
import VueTimepicker from 'vue2-timepicker'
import VueToastr from 'vue-toastr';
import Tooltip from 'vue-directive-tooltip';
import VueSweetalert2 from 'vue-sweetalert2';
import 'vue-directive-tooltip/dist/vueDirectiveTooltip.css';
import 'vue-select/dist/vue-select.css';
import 'sweetalert2/dist/sweetalert2.min.css';

const options = {
  confirmButtonColor: '#00502e',
  cancelButtonColor: '#7f8c8d',
  denyButtonColor: '#969400',
};

Vue.config.productionTip = false

Vue.use(Vuelidate)
Vue.use(VueToastr)
Vue.use(Tooltip);
Vue.use(VueSweetalert2, options);

Vue.component('v-timepicker',VueTimepicker);
Vue.component("v-select", VueSelect.VueSelect);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
